import { z } from 'zod';
// CNPJ validation: exactly 14 digits
const CNPJSchema = z
    .string()
    .length(14)
    .regex(/^\d{14}$/, 'CNPJ must be 14 digits');
// Simplified: removed 'path' field (org_nodes removed)
export const BaseCompanyDTOSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    legalName: z.string(),
    franchiseId: z.string().uuid().nullable(),
    slug: z.string(),
    cnpj: CNPJSchema, // Required CNPJ for companies
    requiresHandoff: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    isDeleted: z.boolean(),
});
export const ExposedCompanyDTOSchema = BaseCompanyDTOSchema.omit({
    isDeleted: true,
    deletedAt: true,
});
//# sourceMappingURL=companies.dto.js.map